
import { API_STATES } from '@/helpers'

const state = {
  accessToken        : null,
  User               : {},
  Company            : {},
  Store              : {},
  assignedStoreIds   : [],
  userPermissions    : { roles : {}, permissions : {} },
  appLoadingState    : API_STATES.NOT_REQUESTED,
  appLoadingErr      : null,
  updateCompanyState : API_STATES.NOT_REQUESTED,
  updateCompanyError : null,
  companyStores      : [],
  companyEmployees   : [],
  openedForms        : [],
  formData           : {},
  openedDeletePopups : []
}
export default state
